import { joinApi } from 'utils/api/api';

import {
  CheckEmailResponse,
  EmailConfig,
  LoginCredentials,
  LoginResponse,
  VerificationConfig,
  VerificationResponse
} from 'types/auth';

import {
  CHECK_EMAIL,
  LOGIN,
  POST_VERIFICATION_CODE,
  VERIFICATION_CODE
} from 'constants/endpoints';

class AuthService {
  async checkEmail(config: EmailConfig): Promise<CheckEmailResponse> {
    const response = await joinApi.post(CHECK_EMAIL, config);
    return response;
  }

  async requestVerificationCode(config: EmailConfig): Promise<void> {
    await joinApi.post(VERIFICATION_CODE, config);
  }

  async postVerificationCode(
    config: VerificationConfig
  ): Promise<VerificationResponse> {
    const response = await joinApi.post(POST_VERIFICATION_CODE, config);
    return response;
  }

  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await joinApi.post(LOGIN, credentials);
    return response;
  }
}

export default new AuthService();
